import React from 'react';
import {
  AnswerMetaText,
  AnswerMeta,
  AnswerText,
  AnswerWrapper,
  AnswerContentWrapper,
  UserIcon,
  UserIconText,
} from '../styles/answer-content';

// is readed, recived, send
export const AnswerContent: React.FC<{
  answerText: string;
  status: 'read' | 'received' | 'sent';
}> = ({ answerText, status }) => {
  return (
    <AnswerWrapper>
      <AnswerContentWrapper>
        <AnswerText>{answerText}</AnswerText>
        <AnswerMeta>
          {status === 'read' && <AnswerMetaText>10:12 • ✓</AnswerMetaText>}
          {status === 'received' && <AnswerMetaText>10:12 • ✓✓</AnswerMetaText>}
          {status === 'sent' && <AnswerMetaText>10:12 • ⏳</AnswerMetaText>}
        </AnswerMeta>
      </AnswerContentWrapper>
      <UserIcon>
        <UserIconText>US</UserIconText>
      </UserIcon>
    </AnswerWrapper>
  );
};
